import { createGenericStore } from '@/stores/utils/genericStore.js'
import axios from 'axios'
import { unwrapResource } from './chatStoreUtils.js'
import { usePresenceUserStore } from './presenceUserStore.js'

const userStatusStoreOptions = {
  state: () => ({
    currentStatus: null,
    options: [],
    isLoadingStatus: false,
    isUpdatingStatus: false,
    isLoadingOptions: false
  }),

  actions: {
    async fetchCurrentStatus() {
      this.isLoadingStatus = true
      this.error = null

      try {
        const response = await axios.get(this.api)
        const status = unwrapResource(response)
        this.currentStatus = status
        this.patchPresenceUserStatus(status)
        return status
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoadingStatus = false
      }
    },

    async updateStatus(status) {
      this.isUpdatingStatus = true
      this.error = null

      try {
        const response = await axios.patch(this.api, { status })
        const updatedStatus = unwrapResource(response)
        this.currentStatus = updatedStatus
        this.patchPresenceUserStatus(updatedStatus)
        return updatedStatus
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isUpdatingStatus = false
      }
    },

    async fetchOptions() {
      this.isLoadingOptions = true
      this.error = null

      try {
        const response = await axios.get(`${this.api}/options`)
        this.options = unwrapResource(response) ?? []
        return this.options
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoadingOptions = false
      }
    },

    patchPresenceUserStatus(status) {
      if (!status?.user_id) {
        return
      }

      usePresenceUserStore().patchUserState({
        id: status.user_id,
        chat_status: status.status,
        chat_status_label: status.label
      })
    }
  }
}

export const useUserStatusStore = createGenericStore(
  'chat-user-status',
  '/api/v1/chat/user-status',
  userStatusStoreOptions
)
